import React from 'react';
import { Box, Grid, Typography, Link, IconButton, Container } from '@mui/material';
import { Facebook, Instagram } from '@mui/icons-material';

const linkSx = {
  color: '#9ca3af',
  display: 'block',
  mb: 1,
  transition: 'color 0.2s ease',
  '&:hover': { color: '#ffffff' },
};

const Footer = () => {
  return (
    <Box
      component="footer"
      sx={{
        color: 'white',
        pt: { xs: 6, md: 8 },
        pb: 4,
        background: 'linear-gradient(180deg, #111827 0%, #1f2937 100%)',
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={{ xs: 4, md: 6 }}>
          {/* Logo and Description */}
          <Grid item xs={12} md={4}>
            <Box display="flex" alignItems="center" gap={1.25}>
              <Box
                component="img"
                src="/app_icon.png"
                alt="Cizlot logo"
                loading="lazy"
                decoding="async"
                sx={{ width: 36, height: 36, borderRadius: '12px' }}
              />
              <Typography variant="h5" sx={{ fontWeight: 800 }}>
                Cizlot
              </Typography>
            </Box>
            <Typography variant="body2" sx={{ mt: 2, color: '#9ca3af', maxWidth: 320, lineHeight: 1.8 }}>
              Transforming the beauty and wellness industry through technology.
            </Typography>
          </Grid>

          {/* Quick Links */}
          <Grid item xs={12} sm={6} md={2}>
            <Typography variant="h6" fontWeight={600} gutterBottom>
              Quick Links
            </Typography>
            <Box>
              <Link href="#features" underline="none" sx={linkSx}>
                Features
              </Link>
              <Link href="#about" underline="none" sx={linkSx}>
                About
              </Link>
              <Link href="#contact" underline="none" sx={{ ...linkSx, mb: 0 }}>
                Contact
              </Link>
            </Box>
          </Grid>

          {/* User Policies */}
          <Grid item xs={12} sm={6} md={2}>
            <Typography variant="h6" fontWeight={600} gutterBottom>
              User Policies
            </Typography>
            <Box>
              <Link href="/legal/user/privacy-policy" underline="none" sx={linkSx}>
                Privacy Policy
              </Link>
              <Link href="/legal/user/terms-of-service" underline="none" sx={{ ...linkSx, mb: 0 }}>
                Terms of Service
              </Link>
            </Box>
          </Grid>

          {/* Partner Policies */}
          <Grid item xs={12} sm={6} md={2}>
            <Typography variant="h6" fontWeight={600} gutterBottom>
              Partner Policies
            </Typography>
            <Box>
              <Link href="/legal/partner/privacy-policy" underline="none" sx={linkSx}>
                Privacy Policy
              </Link>
              <Link href="/legal/partner/terms-of-service" underline="none" sx={{ ...linkSx, mb: 0 }}>
                Terms of Service
              </Link>
            </Box>
          </Grid>

          {/* Social Media Links */}
          <Grid item xs={12} sm={6} md={2}>
            <Typography variant="h6" sx={{ fontWeight: 600, mb: 1 }}>
              Follow Us
            </Typography>

            <Box display="flex" gap={1}>
              <IconButton
                component="a"
                href="https://www.facebook.com/profile.php?id=61571991686656"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Cizlot on Facebook"
                sx={{
                  color: '#e5e7eb',
                  border: '1px solid rgba(255,255,255,0.12)',
                  '&:hover': { backgroundColor: 'rgba(32,133,216,0.25)', color: '#fff' },
                }}
              >
                <Facebook />
              </IconButton>

              <IconButton
                component="a"
                href="https://www.instagram.com/cizlot?igsh=eTZwaTV4emF0YTF3"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Cizlot on Instagram"
                sx={{
                  color: '#e5e7eb',
                  border: '1px solid rgba(255,255,255,0.12)',
                  '&:hover': { backgroundColor: 'rgba(14,165,233,0.25)', color: '#fff' },
                }}
              >
                <Instagram />
              </IconButton>
            </Box>
          </Grid>
        </Grid>

        {/* Footer Bottom */}
        <Box
          sx={{
            mt: { xs: 5, md: 7 },
            pt: 3,
            borderTop: '1px solid rgba(255,255,255,0.10)',
            textAlign: 'center',
          }}
        >
          <Typography variant="body2" sx={{ color: '#9ca3af' }}>
            &copy; 2025 Cizlot. All rights reserved.
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
